import React from 'react';

export default function LocationsIconSolid(props) {
  // fillColor should be the only prop
  const fillColor = props.fillColor || '#184e78';
  return (
      <svg 
        style={props.style ? props.style : { transform: 'translate(0, -12px) scale(.5, .5)' }} 
        width={'37px' }
        height="48px" 
        viewBox="0 0 37 48" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path d="M18.2472989,48 C18.0360144,48 17.8247299,47.9231693 17.6326531,47.7887155 C16.9027611,47.1932773 0,33.1908764 0,18.0744298 C0,7.75990396 7.83673469,0 18.2472989,0 C28.6578631,0 36.4945978,7.77911164 36.4945978,18.0744298 C36.4945978,31.7118848 19.6110444,47.1164466 18.8811525,47.7695078 C18.7082833,47.9231693 18.4777911,48 18.2472989,48 Z M18.2472989,11.5054022 C14.5402161,11.5054022 11.5246098,14.5210084 11.5246098,18.2280912 C11.5246098,21.9351741 14.5402161,24.9507803 18.2472989,24.9507803 C21.9543818,24.9507803 24.969988,21.9351741 24.969988,18.2280912 C24.969988,14.5210084 21.9543818,11.5054022 18.2472989,11.5054022 Z" id="path-1"></path>
        </defs>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Bar/Mobile/AddressBar" transform="translate(-6.000000, -8.000000)">
                <g id="Icon/Nav/Web/Map/Solid-24" transform="translate(-2.000000, 8.000000)">
                    <g id="Color/Library/UW" transform="translate(8.000000, 0.000000)">
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1"></use>
                        <g id="Color/Library/AO" mask="url(#mask-2)" fill={fillColor}>
                            <g transform="translate(-8.000000, 0.000000)" id="Rectangle-Copy-10">
                                <rect x="0" y="0" width="52" height="50"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Iconoclast/LocationsIconSolid/index.js